export function jobSalary(job) {
  const low = Number(job.salary_min);
  const high = Number(job.salary_max);
  const hasLow = Number.isFinite(low) && low > 0;
  const hasHigh = Number.isFinite(high) && high > 0;
  if (!hasLow && !hasHigh) return "Salary not specified";
  if (!job.currency) return "Salary available; currency not specified";
  let format;
  try {
    format = new Intl.NumberFormat("en-GB", {
      style: "currency", currency: job.currency
    });
  } catch {
    return "Salary available; currency not specified";
  }
  const suffix = ["hour", "day", "week", "month", "year"].includes(job.salary_period) ? ` per ${job.salary_period}` : " · pay period not specified";
  if (hasLow && hasHigh && low !== high)
    return `${format.format(low)} – ${format.format(high)}${suffix}`;
  if (hasLow && hasHigh) return `${format.format(low)}${suffix}`;
  return hasLow ? `From ${format.format(low)}${suffix}` : `Up to ${format.format(high)}${suffix}`;
}
